/* eslint-disable react/display-name */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-shadow */
/* eslint-disable @typescript-eslint/no-unsafe-argument */
/* eslint-disable @typescript-eslint/no-unsafe-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/no-unnecessary-condition */
/* eslint-disable jsx-a11y/label-has-associated-control */
import React, {
  useState,
  useEffect,
  useRef,
  forwardRef,
  useImperativeHandle,
  useContext,
} from "react";
import { DateTimePicker } from "@progress/kendo-react-dateinputs";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
  Textarea,
  Input,
  Combobox,
  SelectGroup,
  DatePicker,
  Switch,
} from "@repo/ui";
import { NEXT_DAY_DATE, PREV_DAY_DATE } from "utils/constant";
import { isArrivalBeforeGeneration, showToast } from "utils/helper";
import {
  useGetCustomers,
  useGetCustomerServicePoints,
  useGetPendingReasons,
} from "utils/apis/lookups.api";
import { useUpdateInterBranchServiceStatus } from "utils/apis/inter-branch.api";
import ContainersGrid from "components/containersGrid";
import PartialDeliveryInfo from "components/partialDeliveryInfo";
import { formatDate } from "date-fns";
import { LookUpContext } from "utils/reducers/lookup";
import type { CoinsDenom } from "utils/types/lookup.type";
import AddContainers from "components/addContainers";

const emailRegex = new RegExp(/^[^\s@]+@[^\s@]+\.[^\s@]+$/);
const alphaNum = new RegExp(/^[A-Za-z0-9\s]+$/);
const alpha = new RegExp(/^[A-Za-z\s]+$/);
const mobileRegex = new RegExp(/^[0-9]{10}$/);
const numRegex = new RegExp(/^[0-9\s]+$/);

const jobPriorities = [
  {
    id: 1,
    text: "Critical",
  },
  {
    id: 2,
    text: "High",
  },
  {
    id: 3,
    text: "Normal",
  },
  {
    id: 4,
    text: "Low",
  },
];

const B2BJobCompletionCard = forwardRef(
  ({ request, statusList, statusUpdated }: any, ref) => {
    const currentDate = new Date();
    const { coinContainers } = useContext(LookUpContext);

    const [ddlStatus, setDdlStatus] = useState("");
    const [selectedStatus, setSelectedStatus] = useState("");

    const [ddlReasons, setDdlReasons] = useState("");
    const [remarks, setRemarks] = useState("");
    const [txtRemarksColor, setTxtRemarksColor] = useState("");

    const [vhrNo, setVhrNo] = useState("");
    const [vhrNoColor, setVhrNoColor] = useState("");
    const [locationArrivalTime, setLocationArrivalTime] = useState(currentDate);
    const [generateDateTime, setGenerateDateTime] = useState(currentDate);

    const [repEmployeeId, setRepEmployeeId] = useState("");
    const [txtEmpIdColor, setTxtEmpIdColor] = useState("");
    const [repName, setRepName] = useState("");
    const [txtSRNameColor, setTxtSRNameColor] = useState("");
    const [repEmail, setRepEmail] = useState("");
    const [txtEmailColor, setTxtEmailColor] = useState("");
    const [repMobileNo, setRepMobileNo] = useState("");
    const [txtMobileNoColor, setTxtMobileNoColor] = useState("");

    const [containers, setContainers] = useState<any[]>([]);

    const [ddlCustomers, setDdlCustomers] = useState("");
    const [selectedDestination, setSelectedDestination] = useState("");
    const [onwardLocation, setOnwardLocation] = useState<any>(null);
    const [ddlJobPriority, setDdlJobPriority] = useState("2");
    const [serviceDateTime, setServiceDateTime] = useState(currentDate);
    const [newServiceDate, setNewServiceDate] = useState(NEXT_DAY_DATE);
    const [isHoldingRequested, setIsHoldingRequested] = useState(false);
    const [packedContainers, setPackedContainers] = useState([]);

    const containersList = useRef<any>([]);

    const { data: reasons } = useGetPendingReasons();
    const { data: customers } = useGetCustomers();
    const { data: servicePoints } = useGetCustomerServicePoints(ddlCustomers);

    const onDdlStatusChanged = (value: string) => {
      if (!value) {
        setDdlStatus("");
        setSelectedStatus("");
        return;
      }
      setDdlStatus(value);
      setSelectedStatus(value);
    };

    const validVhrNo = (e: any) => {
      const vhrNo = e.target.value;
      if (!alphaNum.test(vhrNo)) {
        setVhrNoColor("bg-red-500/30 border-red-500");
        return;
      }
      setVhrNoColor("text-success");
    };

    const validateEmployeeId = (e: any) => {
      const employeeId = e.target.value;
      if (!numRegex.test(employeeId)) {
        setTxtEmpIdColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtEmpIdColor("text-success");
    };

    const validateEmail = (e: any) => {
      const email = e.target.value;
      if (!emailRegex.test(email)) {
        setTxtEmailColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtEmailColor("text-success");
    };

    const validateMobile = (e: any) => {
      const mobileNo = e.target.value;
      if (!mobileRegex.test(mobileNo)) {
        setTxtMobileNoColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtMobileNoColor("text-success");
    };

    const validateSRName = (e: any) => {
      const name = e.target.value;
      if (!alpha.test(name)) {
        setTxtSRNameColor("bg-red-500/30 border-red-500");
        return;
      }
      setTxtSRNameColor("text-success");
    };

    const onDdlCustomersChanged = (value: any) => {
      if (!value) {
        setDdlCustomers("");
        return;
      }
      setSelectedDestination("");
      setDdlCustomers(value);
    };

    const onUpdatedData = (data: any) => {
      setPackedContainers(data);
    };

    const deleteContainer = (rowIndex: any) => {
      let updatedContainers: any;

      containers.map((row: any, index) => {
        if (index === rowIndex) {
          updatedContainers = containers.filter(
            (cc: any) => cc.deleteId !== row.deleteId,
          );
        }
        return row;
      });

      setContainers(updatedContainers);
      containersList.current = updatedContainers;
    };

    const onDdlReasonsChanged = (value: string) => {
      setDdlReasons(value);
    };

    const onDestinationLocationChanged = (value: string) => {
      setSelectedDestination(value);

      const dsp: any = servicePoints.find(
        (sp: any) => sp.servicePointId === value,
      );

      if (dsp) {
        setOnwardLocation({
          servicePointId: dsp.servicePointId,
          locationId: dsp.locationId,
          locationName: dsp.locationName,
          locationType: dsp.locationType,
        });
      }
    };

    const {
      mutate: updateStatus,
      isSuccess: statusSuccess,
      isError: statusError,
    } = useUpdateInterBranchServiceStatus();

    useImperativeHandle(ref, () => ({
      onBtnConfirmClicked(e: any) {
        e.stopPropagation();

        // const updateEndpoint = `${apiUrl}/services/b2b/update/request/status`;

        let vhr = null;

        if (!ddlStatus) return showToast("error", "Please select new status.");
        const selectedStatus = ddlStatus;

        if (
          selectedStatus === "Completed" ||
          selectedStatus === "Collected" ||
          selectedStatus === "Pending"
        ) {
          if (!vhrNo) {
            return showToast("error", "VHR No. is required.");
          }
          if (new Date() < new Date(generateDateTime)) {
            showToast(
              "error",
              "'Print Date & Time' should not be greater then current time.",
            );
            return;
          }

          if (
            !isArrivalBeforeGeneration(locationArrivalTime, generateDateTime)
          ) {
            showToast(
              "error",
              "Arrival Time should be less then 'Print Date & Time'",
            );
            return;
          }

          const siteRepresentatives = [
            {
              name: repName,
              employeeId: repEmployeeId,
              mobileNo: repMobileNo,
              email: repEmail,
            },
          ];

          if (
            selectedStatus === "Completed" &&
            packedContainers?.length === 0
          ) {
            showToast("error", "Add Container(s) to continue.");
          }

          const selectedContainers =
            selectedStatus === "Completed"
              ? packedContainers
                  ?.filter((item: any) => item.status === "Delivered")
                  .map((i: any) => ({
                    ...i,
                    declaredValue:
                      i.consignmentType === "Coins"
                        ? ((coinContainers as CoinsDenom[])?.find(
                            (row) =>
                              i.details === row.denomination &&
                              i.containerType === row.containerType,
                          )?.valuePerContainer || 0) * i.count
                        : i.declaredValue,
                    count:
                      i.consignmentType === "Coins"
                        ? i.count - i.returnedCount
                        : i.count,
                    returnedCount: 0,
                  }))
              : containers;

          vhr = {
            vhrNo,
            locationArrivalTime,
            generateDateTime,
            containers: selectedContainers,
            siteRepresentatives,
          };
        }

        if (selectedStatus === "Pending" && !ddlReasons) {
          showToast("error", "Please select pending reason.");
          return;
        }

        let pendingReason = "";

        if (selectedStatus === "Pending") pendingReason = ddlReasons;

        if (
          selectedStatus === "Pending" &&
          pendingReason === "Other" &&
          remarks === ""
        ) {
          showToast("error", "Remarks are required for Other pending reason.");
          setTxtRemarksColor("bg-red-500/30 border-red-500");
          return;
        }

        setTxtRemarksColor("");

        let priority = 2;
        let onwardSPId = "";

        if (selectedStatus === "Forwarded") {
          if (!ddlJobPriority) {
            showToast("error", "Please select priority.");
            return;
          }

          priority = parseInt(ddlJobPriority);

          if (!onwardLocation) {
            showToast("error", "Please select onward location.");
            return;
          }

          onwardSPId = onwardLocation.servicePointId;
        }

        const updateDto = {
          requestId: request.requestId,
          jobNo: request.jobNo,
          status: selectedStatus,
          onwardSPId,
          serviceType: "Inter Branch Service",
          priority,
          requestedCCHolding: isHoldingRequested,
          newServiceDateTime: formatDate(
            (isHoldingRequested || selectedStatus === "Holding"
              ? newServiceDate
              : serviceDateTime) || currentDate,
            "yyyy-MM-dd'T'HH:mm:ss.SSS'Z'",
          ),
          pendingReason,
          remarks,
          vhr,
          packedContainers,
        };

        updateStatus(updateDto);
      },
    }));

    useEffect(() => {
      if (statusSuccess) {
        statusUpdated(false);
        setContainers([]);
        containersList.current = [];
      }
      if (statusError) {
        showToast(
          "error",
          "Something went wrong while updating status. Please try again.",
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusSuccess, statusError]);

    useEffect(() => {
      if (
        request?.status === "Awaiting Delivery" &&
        request?.collectedConsignments?.containers?.length
      ) {
        setPackedContainers(
          request?.collectedConsignments?.containers?.map((i: any) => ({
            ...i,
            status: "Delivered",
          })),
        );
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [request?.collectedConsignments?.containers]);

    return (
      <div className="flex gap-4 mt-4">
        <div className="flex-1">
          <h3 className="font-bold text-md">Select New Status</h3>
          <Select onValueChange={onDdlStatusChanged} value={ddlStatus}>
            <SelectTrigger className="my-3">
              <SelectValue placeholder="Select Status" />
            </SelectTrigger>
            <SelectContent>
              {statusList?.map((item: any) => (
                <SelectItem key={item.id} value={item.id}>
                  {item.text}
                </SelectItem>
              ))}
            </SelectContent>
          </Select>
          {["Pending", "Collected", "Completed"].includes(selectedStatus) && (
            <>
              <div className="flex mt-2 gap-2">
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    VHR No
                  </label>
                  <Input
                    placeholder="E-VHR No"
                    className={`w-full h-10  ${vhrNoColor}`}
                    value={vhrNo}
                    onChange={(e) => {
                      setVhrNo(e.target.value);
                    }}
                    onBlur={validVhrNo}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Location Arrival Time
                  </label>
                  <DateTimePicker
                    className="w-full h-10"
                    value={locationArrivalTime}
                    onChange={(e) => {
                      setLocationArrivalTime(e.target.value as any);
                    }}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Print Date & Time
                  </label>
                  <DateTimePicker
                    className="w-full h-10"
                    value={generateDateTime}
                    onChange={(e) => {
                      setGenerateDateTime(e.target.value as any);
                    }}
                  />
                </div>
              </div>

              <div className="border-b my-3 bg-accent" />
            </>
          )}
          {selectedStatus === "Pending" && (
            <>
              <div className="border-b my-3 bg-accent" />
              <label className="text-sm font-medium leading-none">
                Pending Reasons
              </label>
              <Combobox
                value={ddlReasons}
                data={reasons?.map((item: any) => ({
                  label: item.description,
                  value: item.description,
                }))}
                placeholder="Select Pending Reason"
                setValue={onDdlReasonsChanged}
              />
            </>
          )}

          {["Holding", "Collected"].includes(selectedStatus) && (
            <>
              {selectedStatus === "Collected" && (
                <div className="flex items-center space-x-2">
                  <Switch
                    id="airplane-mode"
                    className="text-sm"
                    checked={isHoldingRequested}
                    onCheckedChange={setIsHoldingRequested}
                  />
                  <label className="tex-sm" htmlFor="airplane-mode">
                    Request Holding
                  </label>
                </div>
              )}
              {isHoldingRequested || selectedStatus === "Holding" ? (
                <>
                  <label className="text-sm font-medium leading-none mt-3 block mb-1">
                    Delivery Date
                  </label>
                  <DatePicker
                    selectedDate={newServiceDate}
                    onSelectDate={setNewServiceDate}
                    disabled={(date) => date < currentDate}
                  />
                </>
              ) : null}
              <div className="border-b my-3 bg-accent" />
            </>
          )}

          {selectedStatus === "Forwarded" && (
            <>
              <div className="border-b my-3 bg-accent" />

              <label className="text-sm font-medium leading-none">
                Customer
              </label>
              <Combobox
                value={ddlCustomers}
                data={customers?.map((item: any) => ({
                  label: item.name,
                  value: item.customerId,
                }))}
                placeholder="Select Customer"
                setValue={onDdlCustomersChanged}
              />

              <div className="border-b my-3 bg-accent" />

              <label className="text-sm font-medium leading-none">
                Select Onward Location
              </label>
              <Combobox
                data={servicePoints?.map((item: any) => ({
                  label: `${item.barcode}-${item.locationId}`,
                  value: item.servicePointId,
                }))}
                value={selectedDestination}
                setValue={onDestinationLocationChanged}
                placeholder="search and select onward location."
              />

              <div className="border-b my-3 bg-accent" />

              <label className="text-sm font-medium leading-none">
                Service Date
              </label>
              <DatePicker
                selectedDate={serviceDateTime}
                onSelectDate={setServiceDateTime}
                disabled={(date) => date < PREV_DAY_DATE}
              />

              <div className="border-b my-3 bg-accent" />

              <label className="text-sm font-medium leading-none">
                Job Priority
              </label>
              <Select onValueChange={setDdlJobPriority} value={ddlJobPriority}>
                <SelectTrigger className="w-full">
                  <SelectValue placeholder="Select Job Priority" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    {jobPriorities.map((item) => (
                      <SelectItem key={item.id} value={item.id as any}>
                        {item.text}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </>
          )}

          {["Forwarded", "Collected", "Completed"].includes(selectedStatus) && (
            <>
              <label className="text-sm font-medium leading-none">
                Site Representatives
              </label>
              <div className="border-b my-3 bg-accent" />
              <div className="flex gap-2 ">
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Name
                  </label>
                  <Input
                    placeholder="Name"
                    className={`w-full h-10  ${txtSRNameColor}`}
                    value={repName}
                    onChange={(e) => {
                      setRepName(e.target.value);
                    }}
                    onBlur={validateSRName}
                  />
                </div>
                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Employee ID
                  </label>
                  <Input
                    placeholder="Employee Id"
                    className={`w-full h-10 ${txtEmpIdColor}`}
                    value={repEmployeeId}
                    onChange={(e) => {
                      setRepEmployeeId(e.target.value);
                    }}
                    onBlur={validateEmployeeId}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Mobile No
                  </label>
                  <Input
                    placeholder="Mobile No"
                    className={`w-full h-10 ${txtMobileNoColor}`}
                    value={repMobileNo}
                    onChange={(e) => {
                      setRepMobileNo(e.target.value);
                    }}
                    onBlur={validateMobile}
                  />
                </div>

                <div className="flex-1">
                  <label className="text-sm font-medium leading-none">
                    Email
                  </label>
                  <Input
                    placeholder="Email"
                    className={`w-full h-10 ${txtEmailColor}`}
                    value={repEmail}
                    onChange={(e) => {
                      setRepEmail(e.target.value);
                    }}
                    onBlur={validateEmail}
                  />
                </div>
              </div>

              {!request?.collectedConsignments?.containers?.length && (
                <>
                  <label className="text-sm font-medium leading-none">
                    Containers
                  </label>
                  <div className="border-b my-3 bg-accent" />

                  <AddContainers
                    type="B2B"
                    consignments={containers}
                    setConsignments={setContainers}
                  />
                </>
              )}
            </>
          )}
        </div>

        <div className="flex-1">
          <h3 className="font-bold text-md">Review</h3>
          {selectedStatus === "Completed" &&
          request?.collectedConsignments?.containers?.length ? (
            <PartialDeliveryInfo
              containers={packedContainers}
              onUpdatedData={onUpdatedData}
            />
          ) : null}
          {containers.length > 0 && (
            <ContainersGrid data={containers} removeRow={deleteContainer} />
          )}
          <label className="text-sm font-medium leading-none mt-3 mb-2 block">
            Remarks
          </label>
          <Textarea
            placeholder="Enter remarks"
            className={`w-full ${txtRemarksColor}`}
            rows={3}
            value={remarks}
            onChange={(e) => {
              setRemarks(e.target.value);
            }}
            onBlur={(e) => {
              if (e.target.value) {
                setTxtRemarksColor("");
              }
            }}
          />
        </div>
      </div>
    );
  },
);

export default B2BJobCompletionCard;
